export default "__VITE_ASSET__B2mF8ntn__"